import React, { useState } from 'react'
import LeaveManagement from '../LeaveManagement';
import AdminLeaveManagement from '../AdminLeaveManagement';
import { jwtDecode } from "jwt-decode";
import Layout from '../../Components/Layout';
export const getUserRole = (token) => {
    try {
        const decoded = jwtDecode(token);
        console.log("Decoded JWT:", decoded);

        const roles = decoded.roles || [];   // roles array from token
        const userName = decoded.userName || decoded.sub || null; // subject claim

        // Expiration (exp is in seconds, convert to ms)
        const expiryTime = decoded.exp ? decoded.exp * 1000 : null;

        return { roles, userName, expiryTime };
    } catch (error) {
        console.error("Invalid token", error);
        return { roles: [], userName: null, expiryTime: null };
    }
};
const Leave = () => {
    const token = localStorage.getItem("token");
    const { roles = [] } = getUserRole(token);


    const isEmployee = roles.includes("ROLE_EMP");
    const isFinance = roles.includes("ROLE_FINANCE");
    const isManager = roles.includes("ROLE_MANAGER");
    const isAdmin = roles.includes("ROLE_ADMIN");
    const isItManager = roles.includes("ROLE_IT_MANAGER");


    const [activeTab, setActiveTab] = useState(
        isAdmin ? "my-leaves" : "leave-requests"
    );
    return (
        <Layout>


            <div className="backgound-main-content">
                <div className="leave-management-container px-2">


                    <ul
                        className="nav nav-tabs  d-flex align-items-center justify-content-between mb-4"
                        style={{
                            borderBottom: " 1px solid #DBDBDB",
                        }}
                    >
                        <div className="d-flex">
                            {(isEmployee || isManager || isItManager || isFinance) && (
                                <li className="nav-item">
                                    <button
                                        className="nav-link fw-semibold px-3"
                                        onClick={() => setActiveTab("leave-requests")}
                                        style={{
                                            backgroundColor: "transparent",
                                            border: "none",
                                            borderBottom:
                                                activeTab === "leave-requests"
                                                    ? "3px solid #00AFEF"
                                                    : "3px solid transparent",
                                            color: activeTab === "leave-requests" ? "#00AFEF" : "#909090",
                                            fontSize: "16px",
                                            transition: "all 0.3s ease",
                                        }}
                                    >
                                        My Leaves
                                    </button>
                                </li>
                            )}

                            {(isManager || isAdmin) && (
                                <li className="nav-item ms-3">
                                    <button
                                        className="nav-link fw-semibold px-3"
                                        onClick={() => setActiveTab("my-leaves")}
                                        style={{
                                            backgroundColor: "transparent",
                                            border: "none",
                                            borderBottom:
                                                activeTab === "my-leaves"
                                                    ? "3px solid #00AFEF"
                                                    : "3px solid transparent",
                                            color: activeTab === "my-leaves" ? "#00AFEF" : "#909090",
                                            fontSize: "16px",
                                            transition: "all 0.3s ease",
                                        }}
                                    >
                                        Leave Requests
                                    </button>
                                </li>
                            )}
                        </div>

                    </ul>



                    {/* 🔵 Tab Content */}
                    <div className="tab-content ">
                        {(isEmployee || isManager || isItManager || isFinance) && activeTab === "leave-requests" && (
                            <div className="tab-pane fade show active">
                                <LeaveManagement />
                            </div>
                        )}

                        {(isManager || isAdmin) && activeTab === "my-leaves" && (
                            <div className="tab-pane fade show active">
                                <AdminLeaveManagement />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </Layout>
    );
};


export default Leave